import { useSmartrrTheme } from "@customer-app/account/views/OperationAquarius/hooks/useSmartrrTheme";
import { useMobileQuery } from "@customer-app/account/views/OperationAquarius/utils";
import { Box, Grid } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { AquariusIconButton } from "@smartrr/shared/customerPortal/components/AquariusIconButton";
import { localize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { ButtonGrid } from "../../../constants";
import { ValidViews } from "../../../OrderOptionsModalInner";
import { ButtonOption, ManageSubscriptionRefs } from "../../types";

export const ModalButtonGrid = ({
  modalRefs,
  buttonOptions,
  areButtonsDisabled,
  view,
  setIconButtonActive,
}: {
  modalRefs: ManageSubscriptionRefs;
  buttonOptions: ButtonOption[];
  areButtonsDisabled: boolean;
  view: ValidViews;
  setIconButtonActive: (index: any) => void;
}) => {
  const theme = useSmartrrTheme();
  const isMobile = useMobileQuery();

  return (
    <Box
      className={prefixClassName("modal-actions-wrapper")}
      id={"manage-subscription-actions"}
      data-testid="manage-subscription-button-row"
      ref={modalRefs.box.ref}
      sx={{
        borderBottom: `1px solid ${theme.modernLineDividers}`,
        transition: ".3s ease-in-out",
        height: "max-content",
        margin: isMobile ? "auto -20px" : "0",
      }}
    >
      <ButtonGrid
        container
        spacing={0}
        ref={modalRefs.button.ref}
        justifyContent={isMobile ? "inherit" : "start"}
        className={prefixClassName("manage-order-buttons")}
        direction="row"
        isMobile={isMobile}
      >
        {buttonOptions.map((ele, index) => {
          return (
            <Grid
              item
              key={index}
              ref={el => (modalRefs.options.current[index] = el!)}
              onClick={() => (areButtonsDisabled ? undefined : setIconButtonActive(index))}
              id={`modal-action-${ele?.label}`}
            >
              <AquariusIconButton
                disabled={areButtonsDisabled}
                iconName={ele?.iconName!}
                size="large"
                label={localize(`customerActions.${ele?.label}`)}
                isActive={view !== "Default"}
              />
            </Grid>
          );
        })}
      </ButtonGrid>
    </Box>
  );
};
